import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'locationify',
  pure: true,
})
export class LocationPipe implements PipeTransform {
  constructor(public translateService: TranslateService) {}

  transform(input: Address): string {
    if (input == null) {
      return this.translateService.instant('COMMON_SEARCH-NO_RESPONSE');
    }

    if (input.city == null && input.state == null && input.country == null) {
        return this.translateService.instant('COMMON_SEARCH-NO_RESPONSE');
    }

    return [input.city, input.state, input.country].filter((item) => item && item.length > 0).join(', ');
  }
}

export interface Address {
  city: string;
  state: string;
  country: string;
}
